import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import PlanCardLatino from 'src/components/common/PlanCardLatino'
import styled from 'styled-components'
import { fireUIRenderEvent } from 'src/modules/analytics/v3'
import { selectStateForProtobuf } from 'src/modules/reducers'
import { selectAnalyticsReady } from 'src/modules/reducers/analytics'
import { latinoPlanData } from 'src/constants/planData/latinoPlanData'
import { useCtaText } from 'src/modules/hooks/useCtaText'
import {
  body,
  colors,
  heading,
  maxWidth,
  mediaQuery,
  spacing,
  typographyMixin,
} from 'src/constants/marketing-ds'

const LAPlanCards = ({
  lang,
  ctaText,
  offerCode,
  discountedPrice,
  cardFootnote,
  market,
  disableFreeTrial,
  promoImg,
}) => {
  const [isEventSent, setIsEventSent] = useState(false)
  const stateForProtobuf = useSelector(selectStateForProtobuf)
  const isAnalyticsReady = useSelector(selectAnalyticsReady)

  const title =
    lang === 'es'
      ? 'Disfruta tus canales favoritos en español a un gran precio'
      : 'Enjoy your favorite channels in Spanish for a great price'

  let planData = lang === 'es' ? latinoPlanData.latino_es_monthly : latinoPlanData.latino_en_monthly
  discountedPrice = discountedPrice || planData.discountPrice

  const ctaCopy = useCtaText({ lang, market, disableFreeTrial, ctaText })

  useEffect(() => {
    if (!isEventSent && planData?.plan && isAnalyticsReady) {
      fireUIRenderEvent(
        {
          element: planData?.plan,
          component: 'latino_plan_cards',
          type: 'latino',
        },
        stateForProtobuf
      )
      setIsEventSent(true)
    }
  }, [isEventSent, planData?.plan, isAnalyticsReady])

  return (
    <StyledBundleSection id="select-plan">
      <div className="section-header">
        <h2>{title}</h2>
      </div>
      <div className="section-content">
        <PlanCardLatino
          offerCode={
            (discountedPrice || planData.discountedPrice) && offerCode
              ? offerCode
              : planData.offerCode
          }
          plan={planData.plan}
          title={planData.title}
          subtitle={planData.subtitle}
          // tagline={data.tagline}
          price={planData.price}
          discountedPrice={discountedPrice || planData.discountedPrice}
          listItems={planData.listItems()}
          ctaText={ctaCopy}
          footnote={cardFootnote || planData.footnote()}
          promoImg={promoImg || planData.promoImg}
          lang={lang}
        />
      </div>
    </StyledBundleSection>
  )
}

export default LAPlanCards

const StyledBundleSection = styled.section`
  color: #fff;
  padding: ${spacing.xl} ${spacing.xs};

  margin: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${colors.gradients.slate.light};
  background-image: null;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  gap: ${spacing.md};
  ${mediaQuery.tablet} {
    gap: ${spacing.xl};
    padding: ${spacing.xxxl} ${spacing.xl};
  }
  ${mediaQuery.desktop} {
    gap: ${spacing.xxl};
  }

  .section-header {
    h2 {
      text-align: center;
      ${typographyMixin(heading.md)}

      ${mediaQuery.tablet} {
        ${typographyMixin(heading.lg)}
      }
    }

    p {
      color: rgb(255, 255, 255);
      font-size: 21px;
      font-weight: 500;
      text-align: center;
      letter-spacing: 0px;
      line-height: 23px;
      margin-top: 20px;
    }
  }

  .section-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
    max-width: ${maxWidth.desktop};
    align-items: center;
    margin-bottom: ${spacing.sm};
  }

  .section-footnote {
    color: ${colors.white};
    text-align: center;
    ${typographyMixin(body.xs)}
  }
`
